import {environment} from 'src/environments/environment';
import { Injectable } from "@angular/core";
import {isInBrowser} from "../utils/clientutils";

@Injectable({
  providedIn: 'root'
})
export class AnalyticsService {
  constructor() {
    const me = this;
    if(!isInBrowser()) return
    window.onerror = function (message, file, line, col, error) {
      if (typeof message === 'string') {
        me.exception(message);
      }
      return false;
    };

  }

  pageChanged(page: Pages) {
    if(!isInBrowser()) return
    (<any>window).gtag('config', environment.gaId, {'page_path': page});
  }

  authFailure(reason: AuthFailureReasons) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'auth', {
      'event_category': 'auth',
      'event_label': reason
    });
  }

  reloadFailure(error: Error) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'page_reload_error', {
      'event_category': 'page_reload_error',
      'event_label': error
    });
  }

  serverDisconnected() {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'server_disconnected');
  }

  notificationPermissionRequestResult(result: string) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'notification_permission', {
      'event_category': 'notification_permission',
      'event_label': result
    });
  }

  userNotFoundWhenCreateChat(user: string) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'user_not_found_when_create_chat', {
      'event_category': 'user_not_found_when_create_chat',
      'event_label': user
    });
  }

  sendPhotoFailure(reason: string) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'upload_image', {
      'event_category': 'upload_image',
      'event_label': reason
    });
  }

  fingerprintError() {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'fingerprint_generate_error', {
      'event_category': 'fingerprint_generate_error',
    });
  }

  wrongUserInServerChat(room: String) {
    /*if(!isInBrowser()) return
    (<any>window).gtag('event', 'user_in_chat_when_disconnected', {
      'event_category': 'user_in_chat_when_disconnected',
      'event_label': room
    });*/

    if(!environment.production) {
      console.log("user_in_chat_when_disconnected");
    }
  }

  userNotFoundInRoom(login: string) {
    /*if(!isInBrowser()) return
    (<any>window).gtag('event', 'user_not_found_in_room_for_remove', {
      'event_category': 'user_not_found_in_room_for_remove',
      'event_label': login
    });*/

    if (!environment.production) {
      console.log("user_not_found_in_room_for_remove");
    }
  }

  sendUserToIgnore(isIgnore: boolean) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'sendUserToIgnore', {
      'event_category': 'sendUserToIgnore',
      'event_label': isIgnore
    });
  }

  registrationError(reason: string) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'registration_error', {
      'event_category': 'registration_error',
      'event_label': reason
    });
  }


  exception(description: String) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'exception', {
      'description': 'error_description',
      'fatal': false   // set to true if the error is fatal
    });
  }

  changeUserPaneWidth(open: boolean) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'changeUserPaneWidth', {
      'event_category': 'changeUserPaneWidth',
      'event_label': 'open'
    });
  }

  savingDataTooLong(duration: number, rooms: number) {
    if(!isInBrowser()) return
    (<any>window).gtag('event', 'savingDataTooLong', {
      'event_category': 'savingDataTooLong',
      'event_label': rooms
    });
  }
}

export enum AuthFailureReasons {
  server = 'server',
  wrongData = 'wrong_data'
}

export enum Pages {
  index = '/',
  login = '/login',
  chat = '/chat',
  not_found = '/not_found',
  registration = '/registration',
  registration_confirm = '/registration/confirm',
  restore = '/restore',
  restore_finish = '/restore/finish',
}
